









































































































































































































































import {
    defineComponent,
    ref,
    computed,
    onMounted,
} from "@vue/composition-api";
import useMap from "@/utilities/useGoogleMaps";
import { mobState, app, alarm } from "@/store/index";
import useVIPContacts from "@/store/useVIPContacts";
import VIPContactViewModel from "@/models/VIPContactViewModel";
import { VueTelInput } from "vue-tel-input";
import useVIPContact from "../store/useVIPContact";
import moment from "moment-timezone"; // ⬅️ add

export default defineComponent({
    components: {
        VueTelInput,
        LoadingDialog: () =>
            import(/* webpackChunkName: "settings" */ "./components/Dialogs/LoadingDialog.vue"),
    },
    setup(_, { root }) {
        const { VIPcontacts, getVIPContacts } = useVIPContacts();
        const { add, remove, update, get, nameRules } = useVIPContact();
        const contactForm = ref<HTMLFormElement>();
        const editContactForm = ref<HTMLFormElement>();
        const map = ref();
        const { googleMapApi } = useMap();
        const location = ref<GeolocationPosition>();
        let myGoogleMap: google.maps.Map;
        let poly: google.maps.Polyline;
        let userMarker: google.maps.Marker;
        let infoWindow: google.maps.InfoWindow;
        let user: google.maps.LatLng;
        const phoneInputRef = ref();
        const phone = ref<string>('');
        const showDialog = ref<boolean>(false);
        const showAddContactDialog = ref<boolean>(false);
        const showEditContactDialog = ref<boolean>(false);
        const name = ref<string>("");
        let editedContact: VIPContactViewModel;
        const errorMessage = ref<string>("");
        const isFetchingPosition = ref<boolean>(true);

        // === helpers for pretty InfoWindows with local time ===
        const userTZ = ref<string>(
            Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC"
        );
        const formatLocal = (ts: number | string, fmt = "YYYY-MM-DD HH:mm:ss z") =>
            (typeof ts === "number" ? moment(ts) : moment.utc(ts))
                .tz(userTZ.value)
                .format(fmt);

        const infoCard = (title: string, rows: Array<[string, string | number]>) => `
    <div style="
      font-family: system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif;
      color:#fff; background:#0b132b; border-radius:12px;
      min-width:260px; max-width:340px; overflow:hidden;">
      <div style="padding:10px 36px 10px 12px; font-weight:600; font-size:14px;">
        ${title}
      </div>
      <div style="padding:10px 12px; background:rgba(255,255,255,.04)">
        ${rows.map(([k, v]) => `
          <div style="display:flex; justify-content:space-between; gap:12px; padding:6px 0; border-bottom:1px solid rgba(255,255,255,.08)">
            <div style="opacity:.85">${k}</div>
            <div style="font-weight:600">${v}</div>
          </div>
        `).join("")}
      </div>
    </div>
  `;

        const user_lat = computed<number>(() => { return alarm.user_lat ? alarm.user_lat : 0; });
        const user_lng = computed<number>(() => { return alarm.user_lng ? alarm.user_lng : 0; });

        const latitude = computed<string>(() => {
            return user_lat.value != 0 ? user_lat.value.toFixed(6) : "-.--";
        });

        const longitude = computed<string>(() => {
            return user_lng.value != 0 ? user_lng.value.toFixed(6) : "-.--";
        });

        const latLetter = computed<string>(() => user_lat.value >= 0 ? "N" : "S");
        const lngLetter = computed<string>(() => user_lng.value >= 0 ? "E" : "W");

        const selectContact = (VIPcontact: VIPContactViewModel) => {
            vueTel.value.phone = VIPcontact.phoneNumber;
            closeContactDialog();
        };

        const showContactDialog = () => { showDialog.value = true; };
        const closeContactDialog = () => { showDialog.value = false; };
        const openAddContactDialog = () => { showAddContactDialog.value = true; };
        const closeAddContactDialog = () => { showAddContactDialog.value = false; };
        const openEditContactDialog = () => { showEditContactDialog.value = true; };
        const closeEditContactDialog = () => { showEditContactDialog.value = false; };

        const editVIPContact = (VIPcontact: VIPContactViewModel) => {
            name.value = VIPcontact.name;
            vueTel2.value.phone = VIPcontact.phoneNumber;
            editedContact = VIPcontact;
            openEditContactDialog();
        };

        const initEditSave = () => {
            if (editContactForm.value) {
                editedContact.name = name.value;
                editedContact.phoneNumber = vueTel2.value.phone;
                update(editedContact).then(() => {
                    getVIPContacts();
                    name.value = "";
                    vueTel2.value.phone = '';
                    closeEditContactDialog();
                });
            }
        }

        const initSave = () => {
            if (contactForm.value) {
                const newContact = new VIPContactViewModel();
                newContact.name = name.value;
                newContact.phoneNumber = vueTel2.value.phone;
                add(newContact).then(() => {
                    getVIPContacts();
                    name.value = "";
                    vueTel2.value.phone = '';
                    closeAddContactDialog();
                });
            };
        };

        const deleteVIPContact = (VIPcontact: VIPContactViewModel) => {
            remove(VIPcontact.id).then(() => {
                getVIPContacts();
            });
        };

        const requestUserPosition = () => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position: GeolocationPosition) => {
                        handlePositionSuccess(position);
                    },
                    (error: GeolocationPositionError) => {
                        handlePositionError(error);
                    },
                    { enableHighAccuracy: true, maximumAge: 0 }
                );
            } else {
                errorMessage.value = "Geolocation is not supported by this browser.";
                app.error = errorMessage.value;
            }
        };

        const handlePositionSuccess = (position: GeolocationPosition) => {
            alarm.setUserLocation(position);
            location.value = position;

            user = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);

            const path = poly.getPath();

            userMarker.setPosition(user);
            userMarker.setVisible(true);
            path.push(user);

            // ✅ pretty card + local time
            const rowsUser: Array<[string, string | number]> = [
                ["Local time", formatLocal(position.timestamp)],
                ["Latitude", userMarker.getPosition().lat().toFixed(6)],
                ["Longitude", userMarker.getPosition().lng().toFixed(6)],
            ];
            if (Number.isFinite(position.coords.accuracy)) {
                rowsUser.push(["Accuracy (m)", Math.round(position.coords.accuracy)]);
            }
            const contentUser = infoCard("User position", rowsUser);

            userMarker.addListener("click", () => {
                infoWindow.close();
                infoWindow.setContent(contentUser);
                infoWindow.open(userMarker.getMap(), userMarker);
            });

            isFetchingPosition.value = false;
            myGoogleMap.setCenter(user);
        };

        const goToGeoPerm = () => {
            root.$router.push({ name: "geo-permission", params: { destination: "map" } });
        };

        const handlePositionError = (error: GeolocationPositionError) => {
            if (error.code === error.PERMISSION_DENIED) {
                errorMessage.value = "User denied the request for geolocation.";
            } else if (error.code === error.POSITION_UNAVAILABLE) {
                errorMessage.value = "Location information is unavailable.";
            } else if (error.code === error.TIMEOUT) {
                errorMessage.value = "The request to get user location timed out.";
            } else {
                errorMessage.value = "An unknown error occurred.";
            }
            app.error = errorMessage.value;
            goToGeoPerm();
        };

        const sendMobMessage = () => {
            if (latitude.value && longitude.value) {
                const phoneData = phoneInputRef.value;
                const number = phoneData.phoneObject ? phoneData.phoneObject.number : phone.value;
                mobState
                    .sendMobMessage({
                        lat: latitude.value,
                        lng: longitude.value,
                        phone: number
                    })
                    .then(() => {
                        app.success = 'MOB message sent successfully.';
                    });
            }
        };

        const vueTel = ref({
            phone: '',
            props: {
                autoFormat: true,
                autoDefaultCountry: true,
                dropdownOptions: {
                    showDialCodeInList: true,
                    showDialCodeInSelection: false,
                    showFlags: true,
                    showSearchBox: true,
                    width: '300px',
                },
                ignoredCountries: ['KP', 'RU'],
                inputOptions: {
                    autocomplete: 'on',
                    showDialCode: true,
                    placeholder: 'Enter phone number',
                    required: true,
                },
                mode: 'international',
                preferredCountries: ['DK', 'NO', 'SE'],
                validCharactersOnly: true,
            },
        });

        const vueTel2 = ref({
            phone: '',
            props: {
                autoFormat: true,
                autoDefaultCountry: true,
                dropdownOptions: {
                    showDialCodeInList: true,
                    showDialCodeInSelection: false,
                    showFlags: true,
                    showSearchBox: true,
                    width: '300px',
                },
                ignoredCountries: ['KP', 'RU'],
                inputOptions: {
                    autocomplete: 'on',
                    showDialCode: true,
                    placeholder: 'Enter phone number',
                    required: true,
                },
                mode: 'international',
                preferredCountries: ['DK', 'NO', 'SE'],
                validCharactersOnly: true,
            },
        });

        onMounted(async () => {
            googleMapApi.load().then(() => {
                console.log("Google Maps API loaded");
                const userPos = new google.maps.LatLng(user_lat.value, user_lng.value);
                infoWindow = new google.maps.InfoWindow();
                userMarker = new google.maps.Marker();

                const userIcon = {
                    url: 'https://dsspoc.azurewebsites.net/img/icons/map-marker-user.svg',
                    scaledSize: new google.maps.Size(80, 80),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(40, 80)
                };

                myGoogleMap = new google.maps.Map(map.value, {
                    center: userPos,
                    mapTypeId: "satellite",
                    zoom: 16,
                    disableDefaultUI: true,
                    backgroundColor: "#000000",
                    zoomControl: false,
                    mapTypeControl: true,
                    mapTypeControlOptions: {
                        style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
                    },
                    fullscreenControl: true
                });

                userMarker.setPosition(userPos);
                userMarker.setMap(myGoogleMap);
                userMarker.setIcon(userIcon);
                userMarker.setTitle("You are here.");
                userMarker.setVisible(true);

                poly = new google.maps.Polyline({
                    strokeColor: "#FF0000",
                    strokeOpacity: 1.0,
                    strokeWeight: 2,
                    zIndex: 10,
                });
                poly.setMap(myGoogleMap);

                myGoogleMap.setCenter(userMarker.getPosition() as google.maps.LatLng);
            });
        });

        return {
            phone,
            sendMobMessage,
            phoneInputRef,
            map,
            latitude,
            longitude,
            latLetter,
            lngLetter,
            showContactDialog,
            showDialog,
            closeContactDialog,
            VIPcontacts,
            selectContact,
            vueTel,
            vueTel2,
            openAddContactDialog,
            closeAddContactDialog,
            initSave,
            name,
            showAddContactDialog,
            contactForm,
            deleteVIPContact,
            showEditContactDialog,
            closeEditContactDialog,
            openEditContactDialog,
            editVIPContact,
            editContactForm,
            initEditSave,
            requestUserPosition,
            isFetchingPosition,
        };
    },
    created: function () {
        const timer = setInterval(() => { this.requestUserPosition(); }, 5000);
        this.$once("hook:beforeDestroy", () => {
            clearInterval(timer);
        });
    },
    data: () => ({
        isValid: false,
        isValid2: false,
    }),
    methods: {
        phoneObject: function (object) {
            this.isValid = object.valid === true;
        },
        phoneObject2: function (object) {
            this.isValid2 = object.valid === true;
        },
    }
});
